export default __webpack_public_path__ + "static/media/sorbet.952804f6.jpg";